import {
    makeStyles,
} from 'app/tss'

const generalInformation = 'generalInformation'
const serviceCenterMetrics = 'serviceCenterMetrics'
const operationalDays = 'operationalDays'
const productMetrics = 'productMetrics'
const containerProductionRate = 'containerProductionRate'
const storages = 'storages'

const getGridTemplateAreas = (isProductionSite: boolean, exists: boolean) => {
    if (exists) {
        return isProductionSite ? `
                "${generalInformation} ${serviceCenterMetrics}"
                "${productMetrics} ${containerProductionRate}"
                "${storages} ${storages}"
                ` : `
                "${generalInformation} ${serviceCenterMetrics}"
                "${productMetrics} ${productMetrics}"
                "${storages} ${storages}"
                `
    }

    return isProductionSite ? `
                "${generalInformation} ${serviceCenterMetrics}"
                "${operationalDays} ${containerProductionRate}"
                "${operationalDays} ${productMetrics}"
                "${storages} ${storages}"
                ` : `
                "${generalInformation} ${serviceCenterMetrics}"
                "${operationalDays} ${productMetrics}"
                "${storages} ${storages}"
                `
}

const useStyles = makeStyles<{
    isProductionSite: boolean,
    exists: boolean
}>()((theme, {
    isProductionSite,
    exists,
}) => {
    const gridTemplateAreas = getGridTemplateAreas(isProductionSite, exists)

    return {
        gridWrapper: {
            display: 'grid',
            gap: theme.spacing(2),
            gridTemplateAreas,
            gridTemplateColumns: 'repeat(2, 1fr)',
        },
        generalInformation: {
            gridArea: generalInformation,
        },
        serviceCenterMetrics: {
            gridArea: serviceCenterMetrics,
        },
        operationalDays: {
            gridArea: operationalDays,
            gridTemplateColumns: 'repeat(4, 1fr)',
        },
        productMetrics: {
            gridArea: productMetrics,
        },
        containerProductionRate: {
            gridArea: containerProductionRate,
        },
        storages: {
            gridArea: storages,
        },
        operationalHours: {
            gridColumn: '1 / -1',
        },
        isLunchBreak: {
            gridColumn: 'span 2',
        },
    }
})

export default useStyles
